// ------------------------------------
// Produto Fotos (Carrosel)
// ------------------------------------
const produtoFotosCarrosel = '#carrosel-produto';
const $produtoFotosCarrosel = $(produtoFotosCarrosel);
const produtoThumbsCarrosel = '#carrosel-produto-thumbs';
const $produtoThumbsCarrosel = $(produtoThumbsCarrosel);

produtoInitSlick();

// Desabilita o plugin de carrosel
function produtoDestroySlick() {
  if ($produtoFotosCarrosel.hasClass('slick-slider')) {
    $produtoFotosCarrosel.slick('unslick');
  }
  if ($produtoThumbsCarrosel.hasClass('slick-slider')) {
    $produtoThumbsCarrosel.slick('unslick');
  }
}

// Aplica o plugin de carrosel
function produtoInitSlick() {
  // Carrosel Principal
  $produtoFotosCarrosel.slick({
    //lazyLoad: 'ondemand',
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
    //adaptiveHeight: true,
    swipe: false,
    infinite: true,
    autoplay: false,
    //asNavFor: produtoThumbsCarrosel,
    // Responsivo
    responsive: [
      // Tablet & Mobile
      {
        breakpoint: 960,
        settings: {
          fade: false,
          swipe: true,
        },
      },
    ],
  });

  // Carrosel Thumbs
  $produtoThumbsCarrosel.slick({
    slidesToShow: 5,
    slidesToScroll: 5,
    vertical: true,
    verticalSwiping: true,
    arrows: false,
    focusOnSelect: true,
    infinite: false,
    asNavFor: produtoFotosCarrosel,
    // Responsivo
    responsive: [
      // Tablet & Mobile
      {
        breakpoint: 960,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
          vertical: false,
          verticalSwiping: false,
        },
      },
    ],
  });
}

slickReinitLazy($produtoFotosCarrosel, produtoInitSlick, produtoDestroySlick);

// ------------------------------------
// Zoom
// ------------------------------------
(function () {
  'use strict';

  /* if (isMedia('xl') || isMedia('lg') || isMedia('md')) {
    $('.carrosel-produto-foto').each(function () {
      const $el = $(this);
      const imgLg = $(this).data('img-lg');
      $el.zoom({
        url: imgLg,
      });
    });
  } */
})();

// ------------------------------------
// Botões de âncora
// ------------------------------------
(function () {
  'use strict';
  $('.btn[href="goto:produto"]').on('click', function (ev) {
    ev.preventDefault();
    if ($('#produto').is(':visible')) {
      smoothScroll('#produto');
    } else if ($('#produto-kits').is(':visible')) {
      smoothScroll('#produto-kits');
    } else {
      smoothScroll('#catalogo');
    }
  });
})();

// ------------------------------------
// Pessoas comprando no momento
// ------------------------------------
let pBuyCurTimer;
function initpBuyCur() {
  let interval = 15; // Intervalo em segundos
  interval = interval * 1000;
  if (pBuyCurTimer !== undefined) {
    clearInterval(pBuyCurTimer);
  }
  const $el = $('.produto-comprando .md-text');
  if ($el.length > 0) {
    let htmlText = $el.html();
    htmlText = htmlText.replace(/{.*}/g, '<span>' + getRandomNumber() + '</span>');
    $el.html(htmlText);
    pBuyCurTimer = setInterval(() => {
      $el.html($el.html().replace(/<span>.*<\/span>/g, '<span>' + getRandomNumber() + '</span>'));
    }, interval);
    function getRandomNumber() {
      return randomNumber(6, 12);
    }
  }
}
initpBuyCur();

// ------------------------------------
// Quantidade em estoque (Gatilho)
// ------------------------------------
function initStockView() {
  const $el = $('.produto-estoque');
  if ($el.length > 0) {
    const estoqueTipo = $el.data('estoque-tipo');
    const estoqueReal = $el.data('estoque-real');
    const estoqueFicticio = $el.data('estoque-ficticio');
    const estoqueView = estoqueTipo == 'real' ? estoqueReal : estoqueFicticio;
    let htmlText = $el.find('.md-text').html();
    htmlText = htmlText.replace(/{.*}/g, '<span>' + estoqueView + '</span>');
    htmlText = htmlText.replace(/<span>.*<\/span>/g, '<span>' + estoqueView + '</span>');
    $el.find('.md-text').html(htmlText);
  }
}
initStockView();

// ------------------------------------
// Contador
// ------------------------------------

// Inicia o contador
let countdown;
function initCountdown() {
  const $countdownEl = $('.countdown');
  if ($countdownEl.length > 0) {
    const mode = $countdownEl.data('mode');
    const minutes = $countdownEl.data('minutes');
    const date = $countdownEl.data('date');
    let futureDate;
    if (mode === 'date') {
      futureDate = new Date(date);
    } else if (mode === 'minutes') {
      futureDate = new Date();
      futureDate.setMinutes(new Date().getMinutes() + Number(minutes));
    }
    if (countdown) {
      countdown.destroy();
    }
    countdown = new Countdown(futureDate);
  }
}
initCountdown();

// Evento de click no contador fixo
$('.countdown-wrapper.fixed').on('click', function () {
  /* if (!previewMode) {
    smoothScroll('#produto');
  } */
  if ($('#produto').is(':visible')) {
    smoothScroll('#produto');
  } else {
    smoothScroll('#produto-kits');
  }
});

// Adiciona um padding bottom na página para compensar a altura do contador fixo
function handlePaddingPagCountFixed() {
  const $countdownFixed = $('.countdown-wrapper.fixed.bottom');
  if ($countdownFixed.length > 0) {
    const countdownHeight = $countdownFixed.height() + 40;
    $('#footer').css('padding-bottom', countdownHeight);
  } else {
    $('#footer').css('padding-bottom', 0);
  }
}
handlePaddingPagCountFixed();

// ------------------------------------
// Variantes e atributos
// ------------------------------------
(function () {
  'use strict';
  const $variants = $('[data-variants]');
  if ($('#produto').length > 0) {
    const variants = $variants.data('variants');
    const $priceOld = $('.produto-det-preco-de');
    const $price = $('.produto-det-preco-por');
    const $quantity = $('.produto-det-quantidade #quantity');
    const $btnBuy = $('#btn-buy');
    const $alertStock = $('.produto-det-indisponivel');
    const $variant = $('#variant');
    const $installmentsInfos = $('.produto-det-preco-parcelamento');
    const $installmentsInfosDest = $('.produto-det-preco-parc');
    let installmentsInfos = $installmentsInfos.data('installments');
    let gateway = installmentsInfos?.gateway;
    let maxInstallments = installmentsInfos?.max_installments || 1;
    let maxInstallmentsFree = installmentsInfos?.max_installments_free || 1;
    let installmentsFreeShow = installmentsInfos?.installments_free_show == '1';
    let installmentsArr = installmentsInfos?.installments || [];
    let variant;

    $('.produto-det-atributo .attr-radio, .produto-det-atributo .attr-select').on('change', function () {
      getAttrVariant();
    });
    $('body').on('recalc-parc', function () {
      getAttrVariant();
    });

    // Retorna o slug da variante com base nos atributos selecionados
    function getAttrVariant() {
      let variantSlug = [];
      $('.produto-det-atributo .attr-radio:checked, .produto-det-atributo .attr-select').each(function () {
        const $input = $(this);
        const attrName = $input.attr('name');
        const attrValue = slugify($input.val());
        const $optValue = $('[data-opt-value="' + attrName + '"]');
        let optTitle;
        if ($input.hasClass('attr-radio')) {
          optTitle = $input.data('title');
        } else if ($input.hasClass('attr-select')) {
          optTitle = $input.find('option:selected').data('title');
        }
        if (optTitle) {
          $optValue.text(optTitle);
        } else {
          $optValue.text('');
        }
        variantSlug.push(attrName + ':' + attrValue);
      });
      variantSlug = variantSlug.join('|');
      showVariantInfos(variantSlug ? variantSlug : 'u');
    }

    function showInstallmentsInfos(listaParcelas) {
      if (maxInstallments > 0 && listaParcelas.length > 0) {
        let lastParcela = listaParcelas.slice(-1)[0];
        if (installmentsFreeShow) {
          lastParcela = listaParcelas.filter((item) => item.sem_juros).slice(-1)[0];
        }
        populaParcelas(listaParcelas);
        if (lastParcela) {
          const semJuros = lastParcela.sem_juros ? ' sem juros' : '';
          const initTxt = lastParcela.sem_juros ? 'Em até' : 'Ou em';
          if ($('.produto-det-preco-container').hasClass('destaque-total')) {
            $installmentsInfosDest.hide();
            $installmentsInfos.html(
              `${initTxt} <b>${lastParcela.num_parcela}x</b> de <b>R$ ${formatMoneyBR(
                lastParcela.valor_parcela,
              )}</b>${semJuros}`,
            );
            $installmentsInfos.css('opacity', 1);
          } else {
            $installmentsInfos.hide();
            $installmentsInfosDest.html(
              `<b>${lastParcela.num_parcela}x</b> de <strong>R$ ${formatMoneyBR(
                lastParcela.valor_parcela,
              )}</strong>${semJuros}`,
            );
            $installmentsInfosDest.css('opacity', 1);
          }
        }
      }
    }

    // Exibe as informações da variante selecionada
    function showVariantInfos(variantSlug) {
      variant = getVariant(variantSlug);
      if (variant !== undefined) {
        //console.log(variant);
        console.log('Variante: ' + variant.sku);

        // Seta a variante no botão
        $btnBuy.data('variant', variant.sku);

        // SKU
        $variant.val(variant.sku);

        // Foca a imagem
        if (variant.image_id != '') {
          focusSlideImage(variant.image_id);
        }

        // Preço antigo
        $priceOld.hide();
        if (Number(variant.old_price) > 0) {
          $priceOld.html('<sup>R$</sup> ' + formatMoneyBR(Number(variant.old_price)));
          $priceOld.show();
        }

        // Preço atual
        $price.html('<sup>R$</sup> ' + formatMoneyBR(Number(variant.sale_price)));
        $('.v-price').text('R$ ' + formatMoneyBR(Number(variant.sale_price)));
        $('.produto-det-preco-total').html('ou <b>R$ ' + formatMoneyBR(Number(variant.sale_price)) + '</b> à vista');

        // Calcula e exibe as informações de parcelamento
        $installmentsInfos.css('opacity', 0);
        $installmentsInfosDest.css('opacity', 0);
        if (maxInstallments > 1) {
          let listaParcelas = [];
          // Mercado Pago
          if (gateway === 'mercadopago') {
            getMercadoPagoInstallments(Number(variant.sale_price), maxInstallments, showInstallmentsInfos);
          }
          // Pagseguro
          else if (gateway === 'pagseguro') {
            getPagSeguroInstallments(
              Number(variant.sale_price),
              maxInstallments,
              maxInstallmentsFree,
              showInstallmentsInfos,
            );
          }
          // Parcelamento interno
          else {
            getInterntInstallments(
              gateway,
              Number(variant.sale_price),
              maxInstallments,
              maxInstallmentsFree,
              showInstallmentsInfos,
            );
          }
        }

        // Descontos
        $('[data-discount]').each(function () {
          const $discount = $(this);
          const $discountPrice = $discount.find('.discount-price');
          const $discountPercent = $discount.find('.discount-percent');
          const discountPercent = $discount.data('discount') ? Number($discount.data('discount')) : 0;
          const discountPrice = (discountPercent * Number(variant.sale_price)) / 100;
          const newPrice = Number(variant.sale_price) - discountPrice;
          $discountPrice.text('R$ ' + formatMoneyBR(newPrice));
          $discountPercent.text(formataDesconto(discountPercent) + '% OFF');
          const method = $discount.data('discount-method');
          const $viewPrice = $('.v-price-' + method);
          if ($viewPrice.length > 0) {
            $viewPrice.text('R$ ' + formatMoneyBR(newPrice));
          }
        });

        // Quantidade
        if (variant.automatic_stock == '1') {
          if (variant.quantity > 0) {
            $quantity.attr('max', variant.quantity);
          } else {
            $quantity.attr('max', 1);
          }
        } else {
          $quantity.removeAttr('max');
        }
        $quantity.val(1);
        initSpinners();
        $('.produto-estoque').data('estoque-real', variant.quantity);
        initStockView();

        // Botão compra
        if (variant.automatic_stock == '1' && variant.quantity == 0) {
          $alertStock.show();
          $btnBuy.prop('disabled', true);
        } else {
          $alertStock.hide();
          $btnBuy.prop('disabled', false);
        }
      }
    }

    // Retorna uma variante com base no slug
    function getVariant(variantSlug) {
      return variants.filter((item) => item.slug == variantSlug)[0];
    }

    // Foca a imagem da variante no carrossel de fotos
    function focusSlideImage(imageID) {
      const $imageSlide = $('#carrosel-produto .carousel-item[data-image="' + imageID + '"]');
      if ($imageSlide.length > 0) {
        const imageIndex = $imageSlide.data('slick-index');
        if ($('#carrosel-produto').hasClass('slick-initialized')) {
          $('#carrosel-produto').slick('slickGoTo', imageIndex);
        }
      }
    }

    // Pré-seleciona a primeira variante disponível
    preSelectVariant();
    function preSelectVariant() {
      let variant = variants.filter((item) => {
        return item.automatic_stock == '0' || (item.automatic_stock == '1' && item.quantity > 0);
      })[0];
      if (variant !== undefined) {
        if (variant.slug === 'u') {
          showVariantInfos('u');
        } else {
          const variantArr = variant.slug.split('|');
          variantArr.forEach((item) => {
            const optArr = item.split(':');
            const optName = optArr[0];
            const optValue = optArr[1];
            let $select = $(`.produto-det-atributo .attr-select[name="${optName}"]`);
            let $radio = $(`.produto-det-atributo .attr-radio[name="${optName}"][value="${optValue}"]`);
            if ($select.length > 0) {
              $select.val(optValue).trigger('change');
            } else if ($radio.length > 0) {
              $radio.prop('checked', true).trigger('change');
            }
          });
        }
      } else {
        variant = variants[0];
        if (variant) {
          showVariantInfos(variant.slug);
        }
      }
    }
  }
})();

// ------------------------------------
// Calcula o parcelamento dos kits
// ------------------------------------
(function () {
  'use strict';
  const $exibeParcKits = $('.prod-col-preco-parcelas');
  if ($exibeParcKits.length > 0) {
    calcParcelasKit();
    $('body').on('recalc-parc', calcParcelasKit);
    function calcParcelasKit() {
      $exibeParcKits.each(function () {
        const $installmentsInfos = $(this);
        const $installmentsDest = $installmentsInfos.parent().find('.prod-col-preco-parc');
        const price = $installmentsInfos.data('price') ? Number($installmentsInfos.data('price')) : 0;
        let installmentsInfos = $installmentsInfos.data('installments');
        let gateway = installmentsInfos?.gateway;
        let maxInstallments = installmentsInfos?.max_installments || 1;
        let maxInstallmentsFree = installmentsInfos?.max_installments_free || 1;
        let installmentsFreeShow = installmentsInfos?.installments_free_show == '1';
        let installmentsArr = installmentsInfos?.installments || [];
        $installmentsInfos.css('opacity', 0);
        $installmentsDest.css('opacity', 0);
        if (maxInstallments > 1) {
          // Mercado Pago
          if (gateway === 'mercadopago') {
            getMercadoPagoInstallments(price, maxInstallments, showInstallmentsInfos);
          }
          // Pagseguro
          else if (gateway === 'pagseguro') {
            getPagSeguroInstallments(price, maxInstallments, maxInstallmentsFree, showInstallmentsInfos);
          }
          // Parcelamento interno
          else {
            getInterntInstallments(gateway, price, maxInstallments, maxInstallmentsFree, showInstallmentsInfos);
          }
        }
        function showInstallmentsInfos(listaParcelas) {
          if (listaParcelas.length > 0) {
            let lastParcela = listaParcelas.slice(-1)[0];
            if (installmentsFreeShow) {
              lastParcela = listaParcelas.filter((item) => item.sem_juros).slice(-1)[0];
            }
            if (lastParcela) {
              const semJuros = lastParcela.sem_juros ? ' <br>sem juros' : '';
              const initTxt = lastParcela.sem_juros ? 'Em até' : 'Ou em';
              if ($('.produto-colunas').hasClass('destaque-total')) {
                $installmentsInfos.html(
                  `${initTxt} <b>${lastParcela.num_parcela}x</b> de <b> R$ ${formatMoneyBR(
                    lastParcela.valor_parcela,
                  )}</b>${semJuros}`,
                );
                $installmentsInfos.css('opacity', 1);
              } else {
                $installmentsDest.html(
                  `<b>${lastParcela.num_parcela}x</b> de <strong>R$ ${formatMoneyBR(
                    lastParcela.valor_parcela,
                  )}</strong><br>${semJuros}`,
                );
                $installmentsDest.css('opacity', 1);
              }
            }
          }
        }
      });
    }
  }
})();

// ------------------------------------
// Ao clicar no botão para adicionar no carrinho
// ------------------------------------
$('#btn-buy').on('click', function (ev) {
  ev.preventDefault();
  if (!previewMode) {
    const variant = $(this).data('variant');
    if (validateCustomizations()) {
      addToCart(variant);
    }
  }
});

// ------------------------------------
// Ao clicar no botão para adicionar no carrinho (Kits Antigos)
// ------------------------------------
$('.btn-buy-kit-old').on('click', function (ev) {
  ev.preventDefault();
  if (!previewMode) {
    const variant = $(this).data('variant');
    addToCart(variant, 1);
  }
});

// Verifica as customizações preenchidas
function validateCustomizations() {
  let customObj = [];
  const $btnBuy = $('#btn-buy');
  if ($('.produto-det-custom').length > 0) {
    let numInvalid = 0;
    $('.produto-det-custom-item .form-input').each(function () {
      const $input = $(this);
      if ($input.prop('required') && !$input.val()) {
        numInvalid++;
      } else if ($input.val() != '') {
        customObj.push({
          customization_id: $input.data('c-id'),
          title: $input.data('c-title'),
          value: $input.val(),
          price_add: $input.data('c-price'),
        });
      }
    });
    if (numInvalid > 0) {
      showAlert('Atenção', 'É necessário informar a personalização!', 'warning');
      return false;
    }
    if (customObj.length > 0) {
      console.log(customObj);
      customObj = JSON.stringify(customObj);
      $btnBuy.data('customizations', customObj);
    }
  }
  return true;
}

// ------------------------------------
// Ao clicar no botão para adicionar no carrinho (Kits Novos)
// ------------------------------------
$('.btn-buy-kit').on('click', function (ev) {
  ev.preventDefault();
  if (!previewMode) {
    const $btnKit = $(this);
    const kitID = $btnKit.attr('id').replace(/\D/g, '');
    const $campoAttr = $('#kit-prod-attr-' + kitID);
    if ($campoAttr.val()) {
      let optKitInfos = $campoAttr.val();
      if (typeof optKitInfos === 'string') {
        optKitInfos = JSON.parse(optKitInfos);
      }
      addToCart(optKitInfos, 2);
    } else {
      $campoAttr.closest('.form-group').addClass('invalid');
    }
  }
});
$('.prod-col-attr [name="kit-prod-attr"]').on('change', function () {
  const $campo = $(this);
  const kitID = $campo.attr('id').replace(/\D/g, '');
  const $btnKit = $('#btn-buy-kit-' + kitID);
  const $kitEl = $('#kit-item-' + kitID);
  const $kitDesconto = $kitEl.find('.prod-col-desc');
  const $kitValor = $kitEl.find('.prod-col-preco-por');
  const $kitValor2 = $kitEl.find('.prod-col-preco-total');
  const $kitValorAntigo = $kitEl.find('.prod-col-preco-de');
  const $kitParcelas = $kitEl.find('.prod-col-preco-parcelas');
  let optKitInfos = $campo.val();
  if (optKitInfos != '') {
    $campo.closest('.form-group').removeClass('invalid');
    optKitInfos = JSON.parse(optKitInfos);
    //console.log(optKitInfos);
    if (optKitInfos.desconto > 0) {
      $kitDesconto.text(optKitInfos.desconto + '% Desconto');
      $kitDesconto.removeClass('d-none');
    } else {
      $kitDesconto.addClass('d-none');
    }
    $kitValor.text('R$ ' + formatMoneyBR(optKitInfos.sale_price));
    $kitValor2.html('ou <b>R$ ' + formatMoneyBR(optKitInfos.sale_price) + '</b> à vista');
    if (optKitInfos.old_price > 0) {
      $kitValorAntigo.text('R$ ' + formatMoneyBR(optKitInfos.old_price));
      $kitValorAntigo.removeClass('d-none');
    } else {
      $kitValorAntigo.addClass('d-none');
    }
    $kitParcelas.data('price', optKitInfos.sale_price);
    $btnKit.removeClass('disabled');
    $btnKit.addClass($btnKit.data('animation-class'));
    //$kitParcelas.trigger('recalc');
    $('body').trigger('recalc-parc');
  }
});

// ------------------------------------
// Adiciona no carrinho
// ------------------------------------

// Informações do carrinho
var cartInfos = $('#infos-base').data('cart-infos') || {};

function addToCart(variant, isKit = false) {
  const urlCart = urlBase + 'core/acoes/checkout/cart.php';
  let type;
  let kitID = 0;
  let productId = 0;
  let kitOptSKU = '';
  let productsList = [];
  let quantity = 0;
  let productQuantity = 1;
  let cartIncrement = $('#infos-base').data('cart-increment');

  // Verifica se o produto já está no carrinho
  if (!cartIncrement && alreadyInCart(variant)) {
    location.href = urlBaseLp + cartInfos.cart_url;
    return false;
  }

  // Produto padrão
  if (!isKit) {
    type = 'default';
    quantity = $('#quantity').val();
    productId = baseProduct;
    productsList.push({
      product_id: baseProduct,
      product_url: baseProductURL,
      variant: variant,
      quantity: quantity,
    });
  }
  // Kit antigo
  else if (isKit == 1) {
    type = 'kit_old';
    quantity = 1;
    productId = baseProduct;
    productsList.push({
      product_id: baseProduct,
      product_url: baseProductURL,
      variant: variant,
      quantity: quantity,
    });
  }
  // Kit novo
  else if (isKit == 2) {
    type = 'kit_new';
    kitID = variant.kit_id;
    productId = baseProduct;
    kitOptSKU = variant.sku; // SKU da opção do kit
    productQuantity = 1;
    productsList = variant.variants.map((vItem) => {
      return {
        product_id: baseProduct,
        product_url: baseProductURL,
        variant: vItem.variant_sku,
        quantity: vItem.quantity,
      };
    });
  }
  const data = {
    store_token: publicToken,
    lp_url: urlBaseLp,
    type: type,
    kit_id: kitID,
    kit_opt_sku: kitOptSKU,
    products: productsList,
    lp_id: baseLanding,
    product_id: productId,
    quantity: productQuantity,
  };

  // Customizações
  if ($('#btn-buy').data('customizations')) {
    data.customizations = JSON.parse($('#btn-buy').data('customizations'));
  }

  showLoader();
  $.getJSON(urlCart, data, function (result) {
    console.log(result);
    if (result.status === 'success') {
      hideLoader();
      location.href = result.checkout_url;
    } else {
      hideLoader();
      showAlert('Erro', 'Não foi possível realizar esta operação.', 'danger');
    }
  }).fail(function (qXHR, textStatus, errorThrown) {
    console.log(qXHR);
    hideLoader();
    showAlert('Erro', 'Não foi possível realizar esta operação.', 'danger');
  });
}

// Popula a lista dos parcelamentos no modal
function populaParcelas(parcelas) {
  const $listaParcelas = $('#modal-det-pagamento .installments-list');
  $listaParcelas.html('');
  parcelas.forEach((parcela) => {
    let semJurosSufix = '';
    if (parcela.sem_juros) {
      semJurosSufix = parcela.num_parcela > 1 ? ' sem juros' : ' à vista';
    }
    $listaParcelas.append(`
  <li class="installments-list-item">
    <span class="installments-list-item-left"><b>${parcela.num_parcela}x</b> de <b>R$ ${formatMoneyBR(
      parcela.valor_parcela,
    )}</b>${semJurosSufix}</span>
    <span class="installments-list-item-right">Total: <b>R$ ${formatMoneyBR(parcela.valor_total)}</b></span>
  </li>`);
  });
}

// Verifica se o produto já foi adicionado ao carrinho
function alreadyInCart(varSKU) {
  const cartItems = cartInfos?.result?.items;
  if (typeof cartInfos === 'object' && cartItems && cartItems.length > 0) {
    return cartItems.some((cartI) => cartI.variant_sku === varSKU);
  }
  return false;
}

// ------------------------------------
// Mercado Pago
// ------------------------------------

// Inicia o Mercado Pago
$('body').on('mp-loaded', function () {
  if (typeof Mercadopago != 'undefined') {
    getMercadoPagoToken(function () {
      $('body').trigger('recalc-parc');
    });
  }
});

// Obtém o token
function getMercadoPagoToken(callback = false) {
  const mpTokenApp = $('#external-js').data('mp-token');
  if (mpTokenApp != '') {
    Mercadopago.setPublishableKey(mpTokenApp);
    if (typeof callback === 'function') {
      callback();
    }
  } else {
    const urlSession = urlBase + 'core/acoes/checkout/mercadopago_get_session.php';
    $.getJSON(`${urlSession}?store_token=${publicToken}`, function (result) {
      //console.log(result);
      Mercadopago.setPublishableKey(result.mp_token);
      if (typeof callback === 'function') {
        callback();
      }
    }).fail(function (result) {
      console.log('Não foi possível obter o token do Mercado Pago.');
      console.log(result);
    });
  }
}

// Obtém as parcelas do cartão
function getMercadoPagoInstallments(amount, parcelas, callback = false) {
  parcelas = !parcelas ? 1 : parcelas;
  const cardBin = 503143;
  if (typeof Mercadopago != 'undefined') {
    Mercadopago.getInstallments(
      {
        bin: cardBin,
        amount: parseFloat(amount),
      },
      function (status, response) {
        if (status == 200) {
          //console.log(response);
          let installments = response[0].payer_costs;
          // Formata as parcelas para o formato utilizado
          let newInstallments = [];
          let countParc = 0;
          installments.forEach((item) => {
            if (countParc < parcelas) {
              countParc++;
              newInstallments.push({
                num_parcela: item.installments,
                valor_total: item.total_amount,
                sem_juros: item.installment_rate === 0,
                valor_parcela: item.installment_amount,
              });
            }
          });
          //console.log(newInstallments);
          if (callback !== false) {
            callback(newInstallments);
          }
        } else {
          console.log('Não foi possível obter as parcelas do Mercado Pago.');
        }
      },
    );
  }
}

// ------------------------------------
// PagSeguro
// ------------------------------------

// Inicia o PagSeguro
$('body').on('ps-loaded', function () {
  if (typeof PagSeguroDirectPayment != 'undefined') {
    getPagSeguroToken(function () {
      $('body').trigger('recalc-parc');
    });
  }
});

// Obtém o token
function getPagSeguroToken(callback = false) {
  const urlSession = urlBase + 'core/acoes/checkout/pagseguro_get_session.php';
  $.getJSON(`${urlSession}?store_token=${publicToken}`, function (result) {
    //console.log(result);
    PagSeguroDirectPayment.setSessionId(result.session_id);
    if (typeof callback === 'function') {
      callback();
    }
  }).fail(function (result) {
    console.log('Não foi possível obter o token do PagSeguro.', result);
  });
}

// Obtém as parcelas do cartão
function getPagSeguroInstallments(amount, parcelas, maxInstallmentsFree, callback = false) {
  parcelas = !parcelas ? 1 : parcelas;
  if (typeof PagSeguroDirectPayment != 'undefined') {
    const cardBrand = 'mastercard';
    const total = amount;
    const opts = {
      amount: total,
      brand: cardBrand,
      success: function (response) {
        let installments = response.installments[cardBrand];
        // Formata as parcelas para o formato utilizado
        let newInstallments = [];
        let countParc = 0;
        installments.forEach((item) => {
          if (countParc < parcelas) {
            countParc++;
            newInstallments.push({
              num_parcela: item.quantity,
              valor_total: item.totalAmount,
              sem_juros: item.interestFree,
              valor_parcela: item.installmentAmount,
            });
          }
        });
        if (callback !== false) {
          callback(newInstallments);
        } else {
          console.log(newInstallments);
        }
      },
      error: function (response) {
        console.log(response);
      },
    };
    // Parcelas sem juros
    if (maxInstallmentsFree && maxInstallmentsFree > 1) {
      opts.maxInstallmentNoInterest = maxInstallmentsFree;
    }
    PagSeguroDirectPayment.getInstallments(opts);
  }
}

// ------------------------------------
// Parcelamento interno
// ------------------------------------
function getInterntInstallments(gateway, amount, maxInstallments, maxInstallmentsFree, callback = false) {
  const urlApi = urlBase + 'core/acoes/checkout/parcelamentos.php';
  const cardNumber = 5031433215406351;
  // Realiza a requisição dos dados
  $.getJSON(
    `${urlApi}?origem=page&gateway=${gateway}&amount=${amount}&cardNumber=${cardNumber}&maxInstallments=${maxInstallments}&maxInstallmentsFree=${maxInstallmentsFree}&store_token=${publicToken}&storeId=${baseLanding}&lp_type=default`,
    function (result) {
      console.log(result);
      let newInstallments = [];
      let countParc = 0;
      if (result.installments) {
        let installments = result.installments;
        // Formata as parcelas para o formato utilizado
        installments.forEach((item) => {
          if (countParc < maxInstallments) {
            countParc++;
            const diffParc = Number(item.amount) - amount;
            const semJuros = diffParc < 0.1; // Tolerância de 1 centavo
            newInstallments.push({
              num_parcela: Number(item.installment),
              valor_total: Number(item.amount),
              //sem_juros: Number(item.amount) <= amount,
              sem_juros: semJuros,
              valor_parcela: Number(item.installment_amount),
            });
          }
        });
      } else {
        console.log('Não foi possível obter o parcelamento.');
      }
      if (callback !== false) {
        callback(newInstallments);
      }
    },
  ).fail(function (result) {
    console.log(result);
  });
}

// Link de compra
$(function () {
  if (!previewMode && typeof buy_link !== 'undefined' && buy_link != '') {
    $('[href="goto:produto"]').on('click', function (ev) {
      ev.preventDefault();
      location.href = buy_link;
      return false;
    });
  }
});
